var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassTooltip",
    {
      attrs: {
        disabled: _vm.getUnavailableReasonToRevertImport(_vm.data) === null,
        contentClass: "tooltip-import-popup",
        content: _vm.labelTooltip
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "card-type-import__wrapper",
          class: { "upsell-action": !_vm.isSubscriptionFeatureEnabled }
        },
        [
          !_vm.isSubscriptionFeatureEnabled && !_vm.loadingMetadata
            ? _c("CompassFeatureBadge", {
                attrs: { size: "small", variant: "upsell" }
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "card-type-import",
              class: _vm.customClass,
              attrs: { "data-bot": _vm.data.dataBot },
              on: { click: _vm.onClickCard }
            },
            [
              _vm.loadingMetadata
                ? _c("CompassSkeleton", {
                    staticClass: "card-type-import-skeleton",
                    attrs: { variant: "block" }
                  })
                : _c("div", { staticClass: "card-type-import__container" }, [
                    _c(
                      "div",
                      { staticClass: "flex-row jc-space" },
                      [
                        _vm.isSubImport
                          ? _c(
                              "div",
                              { staticClass: "card-type-import__icon" },
                              [
                                _c("CompassIcon", {
                                  attrs: { size: "small", icon: _vm.data.icon }
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "typographies-paragraph-small-semibold main-import-title"
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(_vm.data.mainImportTitle) +
                                        "\n                        "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          : _c("CompassObject", {
                              attrs: { size: "small", object: _vm.data.object }
                            }),
                        _vm._v(" "),
                        _c("input", {
                          attrs: { type: "radio" },
                          domProps: { checked: _vm.isSelected }
                        }),
                        _vm._v(" "),
                        _c("span")
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.data.title
                      ? _c(
                          "h4",
                          {
                            staticClass:
                              "card-type-import__title compass-heading compass-heading--5"
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.data.title) +
                                "\n                "
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(_vm.data.description))])
                  ])
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }